import styled from "styled-components";
import { IconButton } from "styles/common/icon-button";
import { ICardCarouselButtonProps } from "./card-carousel.types";

export const CardCarouselWrapper = styled.section`
  position: relative;
`;

export const CardCarouselHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

export const CardCarouselTitle = styled.h3<{
  titleMeta?: { color: string; fontSize: string };
}>`
  font-size: ${({ theme, titleMeta }) =>
    titleMeta?.fontSize ? titleMeta.fontSize : theme.fontSizes["2xl"]};
  font-family: ${({ theme }) => theme.fonts.primary};
  font-weight: bold;
  color: ${({ theme, titleMeta }) =>
    titleMeta?.color ? titleMeta.color : theme.colors.black};
`;

export const CardCarouselSubheading = styled.div`
  flex: 1;
`;

export const CardCarouselCardWrapper = styled.div`
  flex-shrink: 0;
  margin: 0 20px 0 0;
  display: flex;
`;
export const CardCarouselContainer = styled.div<{ isWidthFixed: boolean }>`
  overflow-x: scroll;
  overflow-y: hidden;
  display: flex;
  width: ${({ isWidthFixed }) =>
    isWidthFixed ? "inherit" : "calc(100% + calc(calc(100vw - 100%) / 2))"};
  padding: 8px 8px;
  margin-left: -8px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const CardCarouselPagination = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CardCarouselPaginationButton = styled(
  IconButton
)<ICardCarouselButtonProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  box-shadow: 0px 3px 6px ${({ theme }) => theme.colors.transparent.black70};
  padding: 10px;
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.white};
  cursor: ${({ isDisabled }) => (isDisabled ? "unset" : "pointer")};
  background-color: ${({ isDisabled, theme }) =>
    isDisabled ? theme.colors.neutral[300] : theme.colors.brand[500]};
`;

export const CardCarouselButton = styled.div`
  margin: 20px 0 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
